import React from 'react';
import { LoadingState, PageContainer } from '../ui';
import { LockedFeature } from './LockedFeature';
import { usePlanSurface } from './usePlanSurface';
import type { PlanSurfaceInput } from './planSurface';

/**
 * Direct URL for a plan-gated store page. While the preview flag is on and
 * the plan does not include the feature, the page is a locked placeholder
 * and its children are not mounted, so they cannot call the gated API.
 * With the flag off, children mount as they do today.
 */
export const PlanLockedGate: React.FC<PlanSurfaceInput & { title?: string; children: React.ReactNode }> = ({
  title,
  children,
  feature,
  rank,
  orgFlag,
}) => {
  const surface = usePlanSurface({ feature, rank, orgFlag });
  if (surface.mode === 'pending') {
    return (
      <PageContainer>
        <LoadingState size="page" />
      </PageContainer>
    );
  }
  if (surface.mode === 'locked') {
    return <LockedFeature variant="page" planName={surface.planName} title={title} />;
  }
  return <>{children}</>;
};
